<app-global-style-loader *ifPlatform="'server'"></app-global-style-loader>
<div
  *ngIf="isPopupVisible"
  class="modal-backdrop has-pos-fix full-height full-width"
></div>
<div
  [class.remove-full-height]="
    removeFullHeight || activeViewMode === ViewMode.GALLERY
  "
  class="app-container is-flex has-pos-rel"
  [class.has-side-nav]="showLeftNav || showRightNav"
  #appContainer
>
  <app-error></app-error>
  <app-side-nav
    [class.is-menu]="showLeftNav"
    [showLeftNav]="showLeftNav && !showRightNav"
    [showRightNav]="showRightNav && !showLeftNav"
    (changeRoute)="onRouteChange()"
  ></app-side-nav>
  <app-header
    [currentPage]="currentPage"
    [currentShownListingType]="currentShownListingType"
    *ngIf="!concealHeader"
  >
  </app-header>
  <div
    class="main-content is-flex flex-one is-flex-column has-pos-rel"
    [class.unpadded]="removePadding"
  >
    <router-outlet></router-outlet>
    <router-outlet
      name="popup"
      (activate)="onShowPopup($event)"
      (deactivate)="onHidePopup($event)"
    ></router-outlet>
  </div>
  <div
    *ngIf="!concealFooter"
    class="is-flex flex-one is-flex-column has-pos-rel"
    [class.unpadded]="removePadding"
    (appLazyComponent)="showCmsLinks=true"
  >
    <app-cms-links
      *ngIf="showCmsLinks"
      [hidden]="concealFooter"
      [links]="footerLinks"
      [title]="footerTitle"
      [showNew]="true"
      [isLDP]="isLDP"
      [isLandingPage]="isLandingPage"
    ></app-cms-links>
  </div>
  <app-footer
    *ngIf="!concealFooter"
    [screenSize]="screenSize"
    [currentShownListingType]="currentShownListingType"
    [provinces]="provinces"
  ></app-footer>
  <app-drawer
    class="main-drawer"
    #drawer
  ></app-drawer>
  <app-login [loginSource]="loginSource" *ngIf="showSignIn"></app-login>
  <app-quebec-modal
    *ngIf="showQuebecModal"
    [showModal]="showQuebecModal"
  ></app-quebec-modal>
</div>
